module.exports = __webpack_public_path__ + "static/media/1.66e1b99d.jpg";